var e,
  t = (e = require("react")) && "object" == typeof e && "default" in e ? e.default : e;
module.exports = function (e) {
  var a = e.src,
    c = e.hoverSrc,
    l = e.style,
    n = e.disabled,
    o = e.onClick,
    s = e.className,
    u = t.useState(a),
    r = u[0],
    i = u[1],
    f = t.useCallback(function () {
      i(c);
    }, []),
    d = t.useCallback(function () {
      i(a);
    }, []);
  return t.createElement("img", {
    src: r,
    style: l,
    onMouseOver: f,
    onMouseOut: d,
    onClick: function onClick(e) {
      o && (n || o(e));
    },
    className: s
  });
};